import React from "react";

import { Box, IconButton, TextField, Tooltip } from "@mui/material";

import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";

import CustomButton from "../../../helper-components/input/CustomButton";

import { signUp } from "../../../helper-functions/api/authQueries";
import { inputBackgroundUnblur } from "../../../helper-functions/shared/pageUtils";

import { getLanguage } from "../../../config/language/language";

/**
 * Sign up form.
 *
 * Fields:
 * username
 * email
 * password
 */
export default function SignUpForm(props) {
    const [showPassword, setShowPassword] = React.useState(false);

    const handleClickShowPassword = () => {
        setShowPassword(!showPassword);
    };

    const handleSubmit = (e) => {
        e.preventDefault();

        const data = new FormData(e.currentTarget);
        const body = {
            email: data.get("email"),
            username: data.get("username"),
            password: data.get("password")
        };

        signUp(props, body);
        props.user.setUsername(data.get("username"));
    };

    React.useEffect(() => {
        inputBackgroundUnblur(3, 1.2, "password", "signUpBackground");
    }, []);

    return (
        <Box component="form" id="signupForm" onSubmit={handleSubmit} sx={{ mt: 1 }}>
            <TextField required id="username" label="Username" name="username" autoComplete="nickname" autoFocus fullWidth margin="normal" />

            <TextField required id="email" label="Email Address" name="email" autoComplete="email" fullWidth margin="normal" />

            <TextField
                required
                name="password"
                label="Password"
                id="password"
                autoComplete="new-password"
                fullWidth
                margin="normal"
                type={showPassword ? "text" : "password"}
                InputProps={{
                    endAdornment: (
                        <Tooltip title={`${showPassword ? "Hide" : "Show"} password`} arrow>
                            <IconButton onClick={handleClickShowPassword}>{showPassword ? <VisibilityOffIcon /> : <VisibilityIcon />}</IconButton>
                        </Tooltip>
                    )
                }}
            />

            <CustomButton {...props} title={getLanguage().BUTTON_SIGNUP} className="button" type="submit" fullWidth />
            <CustomButton {...props} title={getLanguage().BUTTON_ALREADY_HAVE_ACCOUNT} path="/signin" variant="text" />
        </Box>
    );
}
